'use client'

import { EndPointTriangleIcon } from '@repo/ui/EndPointTriangleIcon'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { SearchIcon } from '@repo/ui/SearchIcon'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import PropTypes from 'prop-types'

export const CustomDataSearchBox = ({ onChange, options }) => {
  return (
    <ReactSelectMenu
      onChange={onChange}
      items={options}
      value={''}
      sx={{ width: '320px', borderRadius: '28px' }}
      valueCustomRenderFunction={() => ' '}
      optionCustomRenderFunction={renderField}
      searchable
      size="small"
      placeholder={
        <MUIStack direction="row" alignItems="center" gap={2}>
          <SearchIcon sx={{ width: '18px', height: '18px' }} />
          <MUITypography variant="body1" noWrap sx={{ mb: 0, pointerEvents: 'none', opacity: 0.8 }}>
            Search all fields
          </MUITypography>
        </MUIStack>
      }
    />
  )
}

CustomDataSearchBox.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object).isRequired
}

const renderField = (item) => {
  const { value, label, page, field } = item || {}
  if (!value || !label) return null

  return (
    <MUIStack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ cursor: 'pointer', width: '100%', '&:hover': { svg: { opacity: 1 } } }}
      gap={0}
    >
      <MUIStack direction="column">
        <MUITypography
          variant="body2"
          noWrap
          sx={{ mb: 0, pointerEvents: 'none', color: 'primary.light', fontSize: '0.6875rem' }}
        >
          {page.description}
        </MUITypography>
        <MUITypography variant="body1" noWrap sx={{ mb: 0, pointerEvents: 'none' }}>
          {field.description}
        </MUITypography>{' '}
      </MUIStack>
      <EndPointTriangleIcon sx={{ width: '24px', height: '24px', opacity: 0 }} />
    </MUIStack>
  )
}
